var map = {
	"./AcademyOfTomorrow.png": 7564,
	"./flyingglass.svg": 2883,
	"./mag.svg": 4641,
	"./markwood.svg": 1752,
	"./mast.svg": 4987,
	"./owlsroost.svg": 2210,
	"./picturesbytodd.svg": 3493,
	"./wby.svg": 2800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2117;